import JsonData from "./data.json";

const baseUrl = JsonData.baseUrl;

export const portfolioSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Примеры наших работ: удаление повреждений лифтовых кабин",
  "description": "Примеры выполненных проектов по восстановлению лифтов: удаление царапин, ржавчины, химических повреждений.",
  "itemListElement": JsonData.Portfolio.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "image": `${baseUrl}/${item.afterImage}`, // Используем image из data.json
    "url": `${baseUrl}/restoration-portfolio#${item.id}`, // Динамическое создание URL на основе названия файла
    "description": item.title // Используем title для description
  }))
};
